// extracted by mini-css-extract-plugin
export var emailBlockLink = "_g8-0";